'use client';

import React, { useEffect, useRef } from 'react';

const stats = [
  { val: '$98K+', desc: 'Fully loaded annual cost of one in-house SDR: salary, benefits, tools, and management.' },
  { val: '34-40%', desc: 'Annual SDR turnover. Triple the average across all US roles.' },
  { val: '4-6 mo', desc: 'Typical ramp before a new hire produces reliable pipeline.' },
  { val: '$78K+', desc: 'Cost of each departure in recruiting, re-ramping, and lost pipeline.' },
];

export default function ProblemSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[780px]">
          <div className="eyebrow">The problem we replace</div>
          <h2 className="heading-2 text-ink">The in-house SDR math stopped working</h2>
          <p className="mt-4 text-[19px] text-muted-text leading-relaxed max-w-[62ch]">
            A US-based SDR costs roughly $10,000 per month fully loaded. Then the average rep leaves
            within two years, and you pay to recruit and ramp the next one.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {stats?.map((s, i) => (
            <div
              key={s?.val}
              className="rev stat-card bg-white border border-line-color rounded-brand p-6"
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <b>{s?.val}</b>
              <span>{s?.desc}</span>
            </div>
          ))}
        </div>

        <div className="rev gold-strip mt-8" style={{ transitionDelay: '0.32s' }}>
          <div>
            <b className="text-primary">Our reps do not use the role as a stepping stone.</b>{' '}
            CommandVA SDRs are career sales developers, screened in person, working your US hours full
            time. The churn-and-re-ramp cycle is not part of the deal.
          </div>
        </div>
      </div>
    </section>
  );
}